
import { baseEmail } from "./baseEmail.js";

/* email para token - validação de email */

export const templateTokenEmail = ({nome, token}) => 

    baseEmail({
        extraCss: `
        .token-frame {
            display: block !important;
            width: 40% !important;
        }
        `,
        content: `
        <!-- Conteúdo -->
        <table width="90%" cellpadding="0" cellspacing="0" border="0" style="text-align: center;">
            <tr>
                <td style="height: 100px;"></td>
            </tr>
            <tr>
                <td style="font-size: 30px;">Olá, ${nome}.</td>
            </tr>
            <tr>
                <td style="height: 30px;"></td>
            </tr>
            <tr>
            <td style="font-size: 20px; color: #515151">Obrigado pelo seu interesse em nossa plataforma!</td>
            </tr>
            <tr>
                <td style="height: 20px;"></td>
            </tr>
            <tr>
            <td style="font-size: 20px; color: #515151">O envio do token é uma forma segura de garantir a proprietariedade do seu e-mail e a segurança de todos os nossos clientes.</td>
            </tr>
            <tr>
                <td style="height: 30px;"></td>
            </tr>
            <tr>
                <td style="font-size: 20px; color: #515151">Para continuar seu cadastro, digite o token abaixo na plataforma:</td>
            </tr>
            <tr>
                <td style="height: 60px;"></td>
            </tr>

            <!-- Token -->
            <tr>
                <td align="center">
                    <table class="token-frame" cellpadding="5" cellspacing="5" border="0">
                        <tr>${token .split("").map((c) => `<td class="token-box" style="border: solid 2px #D95323; border-radius: 10px; font-size: 2.5rem; padding: 0.5rem 1rem; color: #2A5056; font-weight: bold; background-color: #F7F9F8;">${c}</td>`).join("")}</tr>
                    </table>
                </td>
            </tr>
        `});



/* email para token - validação de email */

export const templateConfigureAgent = ({nome, agente, telefone}) => 

    baseEmail({
        extraCss: `
        .text-mobile-01 {
            font-size: 25px !important;
        }
        .text-mobile-02 {
            font-size: 15px !important;
        }
        .text-mobile-03 {
            font-size: 15px !important;
        }
        .text-mobile-04 {
            font-size: 17px !important;
        }
        .text-mobile-05 {
            font-size: 12px !important;
        }
        `,
        content: `
        <!-- Conteúdo -->
        <table width="90%" cellpadding="0" cellspacing="0" border="0" style="text-align: center;">
            <tr>
                <td style="height: 100px;"></td>
            </tr>
            <tr>
                <td style="font-size: 30px; color: #000000" class="text-mobile-01">${nome},</td>
            </tr>
            <tr>
                <td style="font-size: 25px; color: #000000" class="text-mobile-02">você criou seu agente e ele está pronto para ser testado.</td>
            </tr>
            <tr>
                <td style="height: 40px;"></td>
            </tr>
            <tr>
                <td style="font-size: 20px; color: #2A5056" class="text-mobile-03">O nome do seu agente é:</td>
            </tr>
            <tr>
                <td style="font-size: 22px; font-weight: bold; color: #B23002" class="text-mobile-04">${agente}</td>
            </tr>
            <tr>
                <td style="height: 30px;"></td>
            </tr>
            <tr>
                <td style="font-size: 20px; color: #2A5056" class="text-mobile-03">O número para acionar seu agente é:</td>
            </tr>
            <tr>
                <td style="font-size: 22px; font-weight: bold; color: #B23002" class="text-mobile-04">${telefone}</td>
            </tr>
            <tr>
                <td style="height: 40px;"></td>
            </tr>
            <tr>
                <td style="font-size: 20px; color: #000000" class="text-mobile-02">Você tem 7 dias para testar gratuitamente, aproveite e explore as funcionalidades do seu agente.</td>
            </tr>
            <tr>
                <td style="height: 40px;"></td>
            </tr>
            <tr>
                <td style="font-size: 15px; color: #515151" class="text-mobile-05">Aqui você encontra as instruções para visualizar e sincronizar a agenda do agente</td>
            </tr>
            <tr>
                <td style="height: 60px;"></td>
            </tr>
        `});
